// from https://github.com/dphilipson/typescript-string-enums

export function StringEnum<V extends string>(...values: V[]): {[K in V]: K } {
    const result: any = {};
    values.forEach((value) => result[value] = value);
    return result;
}

export type StringEnum<T> = T[keyof T];